import { render } from "./AsignacionesList.vue?vue&type=template&id=7d9975e7&scoped=true"
import script from "./AsignacionesList.vue?vue&type=script&lang=js"
export * from "./AsignacionesList.vue?vue&type=script&lang=js"

import "./AsignacionesList.vue?vue&type=style&index=0&id=7d9975e7&scoped=true&lang=css"

import exportComponent from "/home/runner/work/system-jj-frontend/system-jj-frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7d9975e7"]])

export default __exports__